<template>
	<section class="departure">
		<h3 class="departure__title">{{ t('race.nextraces.title') }}</h3>
		<ul class="departure__list" v-if="nextRaces">
			<li class="departure__list__item" v-for="next in nextRaces">
				<router-link
						:to="{ name: 'Race', params: {'meeting_id': next.meeting.id, 'race_id': next.id }}"
						:title="next.meeting.code + next.code+' '+next.meeting.track+' '+timeLeft(next.time)"
						class="race">
					<span class="race__number">{{ next.meeting.code + next.code }}</span>
					<span class="race__name">{{ next.meeting.track }}</span>
					<span class="race__date">{{ timeLeft(next.time) }}</span>
					<span class="icon icon--chrono" aria-hidden="true"></span>
				</router-link>
			</li>
			<li class="departure__list__item is-ended" v-if="!nextRaces.length">
				<div class="race">
					<span class="race__number">&nbsp;</span>
					<span class="race__name">{{ t('race.nextraces.no-races') }}</span>
					<span class="race__date">&#8734;</span>
				</div>
			</li>

		</ul>

	</section>
</template>
<script>
	import Vuex from 'vuex';
	import moment from 'moment-timezone';

	export default {
		name: 'NextRaces',

		data() {
			return {}
		},
		computed: {
			...Vuex.mapState([
				'lang'
			]),
			...Vuex.mapGetters([
				'todayRaceData',
			]),

			nextRaces() {
				let nx = [];

				if (!this.todayRaceData) {
					return nx;
				}

				//Change race levels
				for (let meet of this.todayRaceData) {

					for (let race of meet.races) {
						if (moment(race.time).valueOf() >= new Date().valueOf() && race.status === 'OPEN') {
							nx.push(Object.assign({
								meeting: {
									id: meet.id,
									code: meet.code,
									discipline: meet.discipline,
									track: meet.track
								}
							}, race));
						}

					}
				}

				//Sort: early on top
				nx = nx.sort((a, b) => {
					return new Date(a.time) - new Date(b.time);
				});

				//Remove same tracks
				nx = _.uniqWith(nx, function (a, b) {
					return a.meeting.track === b.meeting.track
				});

				return nx;


			}
		},
		watch: {},
		mounted() {
			if (this.runner) {
				this.horse = this.runner.horse;
			}
			window.nxx = this;


		},
		methods: {

			timeLeft(date) {
				var x = new moment(date);
				var y = new moment(new Date());
				var duration = moment.duration(x.diff(y));

				let h = (duration.get('hours') ? duration.get('hours') + 'h' : '');
				let m = duration.get('minutes') ? duration.get('minutes') + ' min' : '';
				return h + ' ' + m;
			}
		}
	}
</script>
<style>

</style>